<!--
 * @Descripttion: diySkin
 * @version: 1.0.0
 * @Author: Jiang ShareFont
 * @Date: 2023-05-19 10:52:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-01-22 15:09:14
-->
<template>
  <div>
    <common-header>
      <template #right>
        <div>
			
          <el-button size="mini" class="confirm" @click="create" type="primary">保存</el-button>
          <el-button size="mini" class="cancel" @click="back" type="primary">取消并返回列表</el-button>
        </div>
      </template>
    </common-header>
    <div class="setpBox">
      <el-steps :active="setp" finish-status="success">
        <el-step title="选择玩法"></el-step>
        <el-step title="选择皮肤"></el-step>
        <el-step title="基础信息配置"></el-step>
        <el-step title="更多配置&保存"></el-step>
      </el-steps>
    </div>
    <div class="setp1" v-if="setp == 1">
      <div class="lottery_type">请选择玩法</div>
      <div class="setpItems">
        <div class="setpItem" :class="lottery_type == 1 ? 'active' : ''" @click="selectPlay(1)">
          <img src="https://static.goubudian.com/Uploads/lottery/2207/62c64cb5872e0.png" alt="">
          <div class="playName">大转盘</div>
          <el-button type="success" icon="el-icon-check" circle size="mini" v-if="lottery_type == 1"></el-button>
        </div>
        <div class="setpItem" :class="lottery_type == 2 ? 'active' : ''" @click="selectPlay(2)">
          <img src="https://static.goubudian.com/Uploads/lottery/2207/62c70441e672f.png" alt="">
          <div class="playName">九宫格</div>
          <el-button type="success" icon="el-icon-check" circle size="mini" v-if="lottery_type == 2"></el-button>
        </div>
        <div class="setpItem" :class="lottery_type == 3 ? 'active' : ''" @click="selectPlay(3)">
          <img src="https://static.goubudian.com/Uploads/lottery/2207/62dc1160720e7.png" alt="">
          <div class="playName">摇一摇</div>
          <el-button type="success" icon="el-icon-check" circle size="mini" v-if="lottery_type == 3"></el-button>
        </div>
        <div class="setpItem" :class="lottery_type == 4 ? 'active' : ''" @click="selectPlay(4)">
          <img src="https://static.goubudian.com/Uploads/lottery/2208/62f7c7b65aaec.png" alt="">
          <div class="playName">扭蛋机</div>
          <el-button type="success" icon="el-icon-check" circle size="mini" v-if="lottery_type == 4"></el-button>
        </div>
		<div class="setpItem" :class="lottery_type == 5 ? 'active' : ''" @click="selectPlay(5)">
		  <img src="https://static.goubudian.com/Uploads/lottery/2509/68bea01d223c2.png" alt="">
		  <div class="playName">幸运盲盒</div>
		  <el-button type="success" icon="el-icon-check" circle size="mini" v-if="lottery_type == 5"></el-button>
		</div>
		<div class="setpItem" :class="lottery_type == 6 ? 'active' : ''" @click="selectPlay(6)">
		  <img src="https://static.goubudian.com/Uploads/lottery/2509/68bea037c9e5a.png" alt="">
		  <div class="playName">砸金蛋</div>
		  <el-button type="success" icon="el-icon-check" circle size="mini" v-if="lottery_type == 6"></el-button>
		</div>
      </div>
    </div>
    <div class="setp1" v-if="setp == 2">
      <div class="lottery_type">请选择皮肤</div>
      <div class="setpItems">
        <div class="setpItemSkin" v-for="item in skinList" :class="item.id == skin_id ? 'active' : ''" :key="item.id"
          @click="selectSkin(item.id)">
          <img :src="item.preview_img" alt="" v-if="lottery_type == 1">
          <img :src="item.nine_preview_img" alt="" v-if="lottery_type == 2">
          <img :src="item.yao_preview_img" alt="" v-if="lottery_type == 3">
          <img :src="item.niu_preview_img" alt="" v-if="lottery_type == 4">
		  <img :src="item.detail_bg_img" alt="" v-if="lottery_type == 5" style="height:auto;">
		  <img :src="item.detail_bg_img" alt="" v-if="lottery_type == 6"  style="height:auto;">
          <div class="playName">{{ item.title }}</div>
          <el-button type="success" icon="el-icon-check" circle size="mini" v-if="skin_id == item.id"></el-button>
        </div>
        <div class="setpItemSkin" @click="setDIY()">
          <img src="@/assets/image/diy_img.png" alt="" />
          <div class="playName">配置自定义皮肤</div>
        </div>
      </div>
    </div>
    <div class="setp1" v-if="setp == 3">
      <div class="lottery_type">请填写基础信息</div>
      <div class="scroll">
        <div class="header  font-14">
          <div class="reward">奖品设置</div>
        </div>
        <div class="settings">
          <el-alert v-if="showAlert1"
          title="点击右方“ + ”号可增加奖项,点击tab标签页上“ x ”号可删除奖项。"   show-icon
          type="info" @close="hideAlert1">
        </el-alert>
          <el-tabs v-model="editableTabsValue" :editable="lottery_type==2?false:true" @tab-remove="tabRemove" @tab-add="tabAdd">
            <el-tab-pane v-for="(item, index) in list" :key="item.title" :label="item.title" :name="item.title">
              <div class="reward-set font-14">
                <p>奖项设置</p>
                <div class="reward-card">
                  <el-form label-width="220px" label-position="left" :rules="baseRules" :model="item"
                    :ref="`BaseInfo${index}`">
                    <el-form-item label="奖品图片">
                      <div class="upload flex justify-center align-center">
                        <ImageCropperModal :visible="cropperVisible" :url="file" :auto-crop-width="autoCropWidth"
                          :auto-crop-height="autoCropHeight" @cancel="cropperVisible = false" @confirm="onConfirm" />
                        <el-upload :show-file-list="false" action :auto-upload="false" :on-change="changeUpload">
                          <div class="upload-img-box" @click="uploadBtn(index)" v-if="item.cover">
                            <img :src="item.cover" class="upload-img" />
                            <div class="delete flex justify-center align-center">
                              <el-button type="danger" icon="el-icon-delete" circle></el-button>
                            </div>
                          </div>

                          <div class="to-upload" v-else @click="uploadBtn(index)">
                            <el-button class="btn" size="default">上传图片</el-button>
                            <div class="tips font-12">
                              请上传jpg、png格式的图片。
                            </div>
                          </div>
                        </el-upload>
                      </div>
                    </el-form-item>
                    <el-form-item label="奖项标题" required prop="name">
                      <el-input class="input" :disabled="item.type == 1" placeholder="请输入奖项标题" v-model="item.name"
                        maxlength="4"></el-input>
                    </el-form-item>
                    <el-form-item label="奖品名称" required prop="desc">
                      <el-input class="input" placeholder="请输入奖品名称" :disabled="item.type == 1" :maxlength="18"
                        v-model="item.desc"></el-input>
                    </el-form-item>
                    <el-form-item label="奖品份数" required prop="num">
                      <div class="count-box">
                        <el-input-number size="mini" value="item.num" v-model="item.num" :min="1" :max="60000" @change="rewardNumInput($event, item)" ></el-input-number>
                      </div>
                    </el-form-item>
                    <el-form-item prop="weight">
                      <template slot="label">
                        <div class="label-box flex align-center">
                          <div class="require">*</div>
                          <div>中奖倍数</div>
                          <el-tooltip class="box-item" effect="dark" :content="msg['weight']" placement="top-start">
                            <img class="tip-icon" src="@/assets/image/tip.png" alt="" />
                          </el-tooltip>
                        </div>
                      </template>
                      <div class="count-box">
                        <el-input-number size="mini" v-model="item.weight"  :step="1" :precision="0" :min="0" :max="10"  @change="weightChange($event, item)"></el-input-number>
                      </div>
                    </el-form-item>
                    <el-form-item prop="weight">
                      <template slot="label">
                        <div class="label-box flex align-center">
                          <div class="require">*</div>
                          <div>实时中奖率</div>
                          <el-tooltip class="box-item" effect="dark" :content="msg['gailv']" placement="top-start">
                            <img class="tip-icon" src="@/assets/image/tip.png" alt="" />
                          </el-tooltip>
                        </div>
                      </template>
                      <div class="count-box">
                        <span v-if="item.weight == 0"> 0%</span>
                        <span v-else>
                          {{  (((item.num - 0) -  (item.hasnum - 0)) * item.weight  / allPrizeNum*100).toFixed(4) +'%' }}
                        </span>    
                 
                      </div>
                    </el-form-item>
                    <div class="ticket-way" v-if="item.type!=1">
                      <el-form-item
                        label="兑奖方式"
                        required
                        label-width="220px"
                      >
                        <el-select
                          v-model="item.get_prize"
                          class="input"
                          placeholder="请选择兑奖方式"
                        >
                          <el-option
                            v-for="(item, index) in ticketWay"
                            :key="item.value"
                            :label="item.value"
							:disabled="item.disabled"
                            :value="index + 1"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <div v-if="item.get_prize === 1">
                        <el-form-item
                          label="请填写备注提示语"
                          label-width="220px"
                        >
                          <el-input
                            class="input"
                            placeholder="请填写备注提示语"
                            v-model="item.addr_remark"
                          ></el-input>
                        </el-form-item>
                        <el-form-item
                          label="设置兑奖截止时间"
                          label-width="220px"
                        >
                          <el-date-picker
                            v-model="item.prize_end_time"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="请选择兑奖截止日期"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </div>
                      <div v-if="item.get_prize === 2">
                        <div class="tips">
                          <span>*</span>
                          请填写至少一种您的联系方式
                        </div>
                        <el-form-item label="手机号" label-width="220px">
                          <el-input
                            class="input"
                            placeholder="请填写手机号"
                            :maxlength="11"
                            @input="prizePhoneInput"
                            :value="item.get_prize_phone"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="微信号" label-width="220px">
                          <el-input
                            class="input"
                            placeholder="请填微信号"
                            @input="prizeWechatInput"
                            :value="item.get_prize_wechat"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="二维码" label-width="220px">
                          <el-upload
                            class="avatar-uploader"
                            :show-file-list="false"
                            :action="actionUrl"
                            :headers="{
                              'X-Token': token,
                            }"
                            :on-success="uploadQrcode"
                          >
                            <div
                              class="
                                avatar-uploader-icon
                                flex
                                align-center
                                justify-center
                              "
                            >
                              <img
                                v-if="item.get_prize_qrcode"
                                :src="item.get_prize_qrcode"
                                class="upload-img"
                              />
                              <i  v-else class="el-icon-plus"></i>
                            </div>
                          </el-upload>
                        </el-form-item>
                      </div>
                      <div v-if="item.get_prize === 3">
                        <el-form-item
                          label="设置兑奖截止时间"
                          label-width="220px"
                        >
                          <el-date-picker
                          v-model="item.prize_end_time"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="请选择兑奖截止日期">
                          </el-date-picker>
                        </el-form-item>
                      </div>
                      <div v-if="item.get_prize === 4">
                        <el-form-item
                          label="填写目标小程序APPID"
                          label-width="220px"
                        >
                        <el-input
                            class="input"
                            placeholder="目标小程序APPID"
                            @input="prizeAppidInput"
                            :value="item.TempAppid"
                          ></el-input>
                        
                        </el-form-item>
                        <el-form-item label="目标小程序路径" label-width="220px">
                          <el-input
                            class="input"
                            placeholder="目标小程序路径"
                            @input="prizeTempPathInput"
                            :value="item.TempPath"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </el-form>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div class="add-empty" v-if="!hasEmptyReward">
            <el-button class="cancel" @click="addEmpty">增加谢谢参与</el-button>
          </div>

        </div>
      </div>
    </div>
    <div class="setp1" v-if="setp == 4">
      <div class="higher-setting">
         
            <el-form label-width="220px" label-position="left">
			  <p style="font-size: 18px;">抽奖介绍</p>
              <el-form-item>
                <template #label>
                  <div class="flex align-center">
                    <div class="custom-label">发起方</div>
                    <el-tooltip
                      class="box-item"
                      effect="dark"
                      :content="msg['organizer']"
                      placement="top-start"
                    >
                      <img
                        class="tip-icon"
                        src="@/assets/image/tip.png"
                        alt=""
                      />
                    </el-tooltip>
                  </div>
                </template>
                <el-input
                  class="input"
                  placeholder="请输入发起方"
                  v-model="organizer"
                ></el-input>
              </el-form-item>
              <el-form-item label="活动说明">
                <el-input
                  class="input"
                  type="textarea"
                  placeholder="请填写活动说明"
                  v-model="live_desc"
                ></el-input>
              </el-form-item>
              <el-form-item label="奖品介绍">
                <el-input
                  class="input"
                  type="textarea"
                  placeholder="请填写奖品介绍"
                  v-model="prize_desc"
                ></el-input>
              </el-form-item>
              <el-form-item label="介绍图片">
                <el-upload
                  class="avatar-uploader"
                  :show-file-list="false"
                  :disabled="prize_img.length === 5"
                  :action="actionUrl"
                  :headers="{
                    'X-Token': token,
                  }"
                  :on-success="uploadPrizeImg"
                >
                  <div class="flex reward-img-box">
                    <div
                      class="upload-img-box"
                      v-for="item in prize_img"
                      :key="item"
                      @click.stop=""
                    >
                      <img :src="item" class="upload-img" />
                      <div class="delete flex justify-center align-center">
                        <div
                          @click.stop="deletePrizeImg(item)"
                          class="icon"
                        >
                        <i class="el-icon-delete"></i>
                      </div>
                      </div>
                    </div>
                    <div
                      class="
                        avatar-uploader-icon
                        flex
                        align-center
                        justify-center
                      "
                      v-show="prize_img.length < 5"
                    >
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                </el-upload>
              </el-form-item>
		
			  <p style="font-size: 18px;margin-top: 18px;">玩法设置</p>
		
			      <el-form-item>
			        <template #label>
			          <div class="flex align-center">
			            <div class="custom-label">私密模式（多码）</div>
			            <el-tooltip
			              class="box-item"
			              effect="dark"
			              :content="msg['multi']"
			              placement="top-start"
			            >
			              <img
			                class="tip-icon"
			                src="@/assets/image/tip.png"
			                alt=""
			              />
			            </el-tooltip>
			          </div>
			        </template>
			        <el-switch
			          v-model="is_multi"
			          inline-prompt
			          active-text="是"
			          inactive-text="否"
			          inactive-color="#ff4949"
			          active-color="#674eff"
			          :active-value="1"
			          :inactive-value="0"
			          @change="multiChange"
			        ></el-switch>
			      </el-form-item>
			      <el-form-item>
			        <template #label>
			          <div class="flex align-center">
			            <div class="custom-label">仅限群内抽奖</div>
			            <el-tooltip
			              class="box-item"
			              effect="dark"
			              :content="msg['wechat']"
			              placement="top-start"
			            >
			              <img
			                class="tip-icon"
			                src="@/assets/image/tip.png"
			                alt=""
			              />
			            </el-tooltip>
			          </div>
			        </template>
			        <el-switch
			          v-model="is_wechat"
			          inline-prompt
			          active-text="是"
			          inactive-text="否"
			          inactive-color="#ff4949"
			          active-color="#674eff"
			          :active-value="1"
			          :inactive-value="2"
			          @change="wechatChange"
			        ></el-switch>
			      </el-form-item>
				  <el-form-item label="仅限公众号粉丝参加">
				    <template #label>
				      <div class="flex align-center">
				        <div class="custom-label">仅限公众号粉丝参加</div>
				        <el-tooltip
				          class="box-item"
				          effect="dark"
				          :content="msg['is_gzh_fans']"
				          placement="top-start"
				        >
				          <img
				            class="tip-icon"
				            src="@/assets/image/tip.png"
				            alt=""
				          />
				        </el-tooltip>
				        <div class="example" @click="toExample" style="cursor:pointer;margin-left:5px;color:#674eff;text-decoration:underline">示例</div>
				      </div>
				    </template>
				    <el-switch
				      v-model="is_gzh_fans"
				      inline-prompt
				      active-text="是"
				      inactive-text="否"
				      inactive-color="#ff4949"
				      active-color="#674eff"
				      :active-value="1"
				      :inactive-value="0"
				      @change="gzhChange"
				    ></el-switch>
				  </el-form-item>
				  <el-form-item
				    label="请授权公众号"
				    v-if="is_gzh_fans"
				  >
				    <el-select
				      v-model="gzh_appid"
				      class="input"
				      placeholder="请选择授权公众号"
				      no-data-text="请前往手机端授权"
				      size="large"
				      v-if="gzhList.length > 0"
				    >
				      <el-option
				        v-for="item in gzhList"
				        :key="item.authorization_info.authorizer_appid"
				        :label="item.authorizer_info.nick_name"
				        :value="item.authorization_info.authorizer_appid"
				      >
				      </el-option>
				    </el-select>
				    <el-select
				      v-model="gzh_appid"
				      class="input"
				      placeholder="请选择授权公众号"
				      no-data-text="请前往手机端授权"
				      size="large"
				      :disabled="gzhList.length > 0 ? false : true"
				      @click="showCreate"
				      v-else
				    >
				      <el-option
				        v-for="item in gzhList"
				        :key="item.authorization_info.authorizer_appid"
				        :label="item.authorizer_info.nick_name"
				        :value="item.authorization_info.authorizer_appid"
				      >
				      </el-option>
				    </el-select>
				  </el-form-item>
				  <el-form-item
				    label="设置关键字回复"
				    v-if="is_gzh_fans"
				  >
				    <el-input
				      class="input"
				      placeholder="请输入关键字"
				      v-model="gzh_keyword"
				      :disabled="gzhList.length > 0 ? false : true"
				      @click="showCreate"
				      style="width:200px"
				    ></el-input>
				  </el-form-item>
		
			
			  <p style="font-size: 18px; margin-top: 40px;">显示设置</p>
			  <el-form-item>
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">是否显示参与人数</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['show_user_num']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <el-switch
			      v-model="show_user_num"
			      inline-prompt
			      active-text="是"
			      inactive-text="否"
			      inactive-color="#ff4949"
			      active-color="#674eff"
			      :active-value="1"
			      :inactive-value="2"
			    ></el-switch>
				
			  </el-form-item>
              <el-form-item>
                <template #label>
                  <div class="flex align-center">
                    <div class="custom-label">是否显示奖品份数</div>
                    <el-tooltip
                      class="box-item"
                      effect="dark"
                      :content="msg['show_prize_num']"
                      placement="top-start"
                    >
                      <img
                        class="tip-icon"
                        src="@/assets/image/tip.png"
                        alt=""
                      />
                    </el-tooltip>
                  </div>
                </template>
                <el-switch
                  v-model="show_prize_num"
                  inline-prompt
                  active-text="是"
                  inactive-text="否"
                  inactive-color="#ff4949"
                  active-color="#674eff"
                  :active-value="1"
                  :inactive-value="0"
                ></el-switch>
              </el-form-item>
			  <el-form-item  v-if="lottery_type > 2">
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">是否显示奖品</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['show_prize']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <el-switch
			      v-model="show_prize"
			      inline-prompt
			      active-text="是"
			      inactive-text="否"
			      inactive-color="#ff4949"
			      active-color="#674eff"
			      :active-value="1"
			      :inactive-value="2"
			    ></el-switch>
			  </el-form-item>
			  <el-form-item>
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">是否显示滚动中奖记录</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['hidden_win']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <el-switch
			      v-model="hidden_win"
			      inline-prompt
			      active-text="是"
			      inactive-text="否"
			      inactive-color="#ff4949"
			      active-color="#674eff"
			      :active-value="0"
			      :inactive-value="1"
			    ></el-switch>
			  </el-form-item>
			  <el-form-item >
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">允许参与人查看中奖名单</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['show_win_list']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <el-switch
			      v-model="show_win_list"
			      inline-prompt
			      active-text="是"
			      inactive-text="否"
			      inactive-color="#ff4949"
			      active-color="#674eff"
			      :active-value="1"
			      :inactive-value="2"
			    ></el-switch>
			  </el-form-item>
             
			  <el-form-item >
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">开启订阅消息</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['is_subscribe']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <el-switch
			      v-model="is_subscribe"
			      inline-prompt
			      active-text="是"
			      inactive-text="否"
			      inactive-color="#ff4949"
			      active-color="#674eff"
			      :active-value="1"
			      :inactive-value="2"
			    ></el-switch>
			    </el-form-item>
			  
			   <p style="font-size: 18px;margin-top: 40px;">分享与推广</p>
			   <el-form-item label="发起人是否能参与">
			     <template #label>
			       <div class="flex align-center">
			         <div class="custom-label">发起人是否能参与</div>
			         <el-tooltip
			           class="box-item"
			           effect="dark"
			           :content="msg['is_join']"
			           placement="top-start"
			         >
			           <img
			             class="tip-icon"
			             src="@/assets/image/tip.png"
			             alt=""
			           />
			         </el-tooltip>
			       </div>
			     </template>
			     <el-switch
			       v-model="is_join"
			       inline-prompt
			       active-text="是"
			       inactive-text="否"
			       inactive-color="#ff4949"
			       active-color="#674eff"
			       :active-value="1"
			       :inactive-value="0"
			     ></el-switch>
			   </el-form-item>
			   <el-form-item label="参与人能否分享">
			     <template #label>
			       <div class="flex align-center">
			         <div class="custom-label">参与人能否分享</div>
			         <el-tooltip
			           class="box-item"
			           effect="dark"
			           :content="msg['is_share']"
			           placement="top-start"
			         >
			           <img
			             class="tip-icon"
			             src="@/assets/image/tip.png"
			             alt=""
			           />
			         </el-tooltip>
			       </div>
			     </template>
			     <el-switch
			       v-model="is_share"
			       inline-prompt
			       active-text="是"
			       inactive-text="否"
			       inactive-color="#ff4949"
			       active-color="#674eff"
			       :active-value="1"
			       :inactive-value="0"
			       :disabled="is_multi==1?true:false"
			     ></el-switch>
			   </el-form-item>
			  <p style="font-size: 18px;margin-top: 40px;">抽奖次数设置</p>
			  <el-form-item v-if="is_multi!=1">
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">每人可抽奖次数</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['join_num']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <div class="count-box flex align-center">
			      <el-input-number v-model="join_num" :step="1" :min="1" :max="99"  @change="joinNumInput"   size="mini"></el-input-number>
			    </div>
			  </el-form-item>
			  <el-form-item v-if="(join_num > 1 && is_multi!=1 )||is_repeat_win == 1">
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">是否允许一人多次中奖</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['is_repeat_win']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <el-switch
			      v-model="is_repeat_win"
			      inline-prompt
			      active-text="是"
			      inactive-text="否"
			      inactive-color="#ff4949"
			      active-color="#674eff"
			      :active-value="1"
			      :inactive-value="0"
			    ></el-switch>
			  </el-form-item>
			  <el-form-item
			    v-if="
			      is_repeat_win && is_multi!=1
			    "
			  >
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">每人每日可抽奖次数</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['daily_upper']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <div class="count-box flex align-center">
			      <el-input-number v-model="daily_upper" :step="1" :min="0" :max="99"  @change="dailtUpperInput"   size="mini"></el-input-number>
			    </div>
			  </el-form-item>
			  <el-form-item>
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">是否开启裂变</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['is_fission']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <el-switch
			      v-model="is_fission"
			      inline-prompt
			      active-text="是"
			      inactive-text="否"
			      inactive-color="#ff4949"
			      active-color="#674eff"
			      :active-value="1"
			      :inactive-value="0"
				  @change="isFissionChange"
			    ></el-switch>
			  </el-form-item>
			  <el-form-item
			    v-if="
			      is_fission ==1 
			    "
			  >
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">邀请几人增加次数</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['friend_num']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <div class="count-box flex align-center">
			      <el-input-number v-model="friend_num" :step="1" :min="1" :max="10"  size="mini"></el-input-number>
			    </div>
			  </el-form-item>
			  
			  
			  
			   <p style="font-size: 18px;margin-top: 40px;">参与条件设置</p>
			   <el-form-item >
				 <template #label>
				   <div class="flex align-center">
				     <div class="custom-label">凭口令参与</div>
				     <el-tooltip
				       class="box-item"
				       effect="dark"
				       :content="msg['password']"
				       placement="top-start"
				     >
				       <img
				         class="tip-icon"
				         src="@/assets/image/tip.png"
				         alt=""
				       />
				     </el-tooltip>
				   </div>
				 </template>
			     <div class="count-box">
					 <el-input
					   class="input"
					   placeholder="设置口令，例：“粉丝福利”"
					   v-model="password"
					 ></el-input>
			      
			     </div>
			   </el-form-item>
			  <el-form-item >
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">允许匿名参与</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['is_anonymous']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <el-switch
			      v-model="is_anonymous"
			      inline-prompt
			      active-text="是"
			      inactive-text="否"
			      inactive-color="#ff4949"
			      active-color="#674eff"
			      :active-value="1"
			      :inactive-value="0"
			    ></el-switch>
			  </el-form-item>
             <!-- <el-form-item v-if="version_id !== '1'">
                <template #label>
                  <div class="flex align-center">
                    <div class="custom-label">授权手机号参与抽奖</div>
                    <el-tooltip
                      class="box-item"
                      effect="dark"
                      :content="msg['must_phone']"
                      placement="top-start"
                    >
                      <img
                        class="tip-icon"
                        src="@/assets/image/tip.png"
                        alt=""
                      />
                    </el-tooltip>
                  </div>
                </template>
                <el-switch
                  v-model="must_phone"
                  inline-prompt
                  active-text="是"
                  inactive-text="否"
                  inactive-color="#ff4949"
                  active-color="#674eff"
                  :active-value="1"
                  :inactive-value="0"
                ></el-switch>
              </el-form-item> -->
              
            
			  <el-form-item >
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">是否限定参与地区（手机端）</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['apoint_address']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <el-switch
			      v-model="apoint_address"
			      inline-prompt
			      active-text="是"
			      inactive-text="否"
			      inactive-color="#ff4949"
			      active-color="#674eff"
			      :active-value="1"
			      :inactive-value="2"
				  :disabled="true"
			    ></el-switch>
			  </el-form-item>
			  <el-form-item >
			    <template #label>
			      <div class="flex align-center">
			        <div class="custom-label">是否要填写信息（手机端）</div>
			        <el-tooltip
			          class="box-item"
			          effect="dark"
			          :content="msg['is_write']"
			          placement="top-start"
			        >
			          <img
			            class="tip-icon"
			            src="@/assets/image/tip.png"
			            alt=""
			          />
			        </el-tooltip>
			      </div>
			    </template>
			    <el-switch
			      v-model="is_write"
			      inline-prompt
			      active-text="是"
			      inactive-text="否"
			      inactive-color="#ff4949"
			      active-color="#674eff"
			      :active-value="1"
			      :inactive-value="2"
			  	  :disabled="true"
			    ></el-switch>
			  </el-form-item>

              <p style="font-size: 18px;margin-top: 40px;">其他设置</p>
              <el-form-item label="一键复制">
                <template #label>
                  <div class="flex align-center">
                    <div class="custom-label">一键复制</div>
                    <el-tooltip
                      class="box-item"
                      effect="dark"
                      :content="msg['copy_title']"
                      placement="top-start"
                    >
                      <img
                        class="tip-icon"
                        src="@/assets/image/tip.png"
                        alt=""
                      />
                    </el-tooltip>
                  </div>
                </template>
                <div class="copy-box flex">
                  <el-input
                    class="input"
                    placeholder="标题，最多50位"
                    v-model="copy_title"
                  ></el-input>
                  <el-input
                    class="input last-input"
                    type="textarea"
                    placeholder="要被复制的内容"
                    v-model="copy_desc"
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </div>
		
		  <!-- <p style="font-size: 18px;margin-top: 40px;">VIP功能</p>
		    <el-form label-width="220px" label-position="left">
		      <el-form-item>
		        <template #label>
		          <div class="flex align-center">
		            <div class="custom-label">开启纯净版</div>
		            <el-tooltip
		              class="box-item"
		              effect="dark"
		              :content="msg['vip']"
		              placement="top-start"
		            >
		              <img
		                class="tip-icon"
		                src="@/assets/image/tip.png"
		                alt=""
		              />
		            </el-tooltip>
		          </div>
		        </template>
		        <el-switch
		          v-model="vip_advanced"
		          inline-prompt
		          active-text="是"
		          inactive-text="否"
		          inactive-color="#ff4949"
		          active-color="#674eff"
		          :active-value="1"
		          :inactive-value="0"
		          @change="vipChange"
		        ></el-switch>
		      </el-form-item>
		      <div class="vip_txt2" v-if="mc.order_id">已开通会员权利，到期时间：{{mc.end_time}}</div>
		      <div class="vip_txt2" v-else>您还不是会员</div>
		    </el-form> -->
		
    </div>

    <div class="setpNextBox" v-if="setp == 1">
      <el-button style="margin-top: 12px;" @click="next" type="primary">下一步选择皮肤</el-button>
    </div>
    <div class="setpNextBox" v-if="setp == 2">
      <el-button style="margin-top: 12px;" @click="prev" type="primary" v-if="lottery_id==''">上一步选择玩法</el-button>
      <el-button style="margin-top: 12px;" type="primary" :disabled="true" v-else>上一步选择玩法</el-button>
      <el-button style="margin-top: 12px;" @click="next" type="primary">下一步配置基本信息</el-button>
    </div>
    <div class="setpNextBox" v-if="setp == 3">
      <el-button style="margin-top: 12px;" @click="prev" type="primary">上一步选择皮肤</el-button>
      <el-button style="margin-top: 12px;" @click="next" type="primary">下一步更多信息&保存</el-button>
    </div>
    <div class="setpNextBox" v-if="setp == 4">
      <el-button style="margin-top: 12px;" @click="prev" type="primary">上一步配置基本信息</el-button>
      <el-button style="margin-top: 12px;" @click="create" type="primary">保存</el-button>
    </div>
    <!-- <div class="new flex">
    <div
      class="left"
      :class="{
        'left-pack-up': expand,
        'left-expand': packUp,
      }"
    >
    </div>
    <div
      class="right"
      :class="{
        'pack-up': packUp,
        expand: expand,
      }"
    >
      <div class="pack-up-btn" @click="toPackUp"  :style="{backgroundImage: 'url(' + require('@/assets/image/uiio.png') + ')' }">
        <i class="el-icon-arrow-right arrow-right"  v-if="!packUp"></i>
        <i class="el-icon-arrow-left arrow-right"   v-else></i>
      </div>
      <div class="scroll">
      </div>
    </div>
  </div> -->
  <el-dialog title="创建提示"  :visible.sync="showCreateDialog" width="370px">
    <template #default>
      <div>
        <p>您已成功{{ lottery_id ? "修改" : "创建" }}大转盘抽奖</p>
        <p>您预设的奖品份数为{{ totalPrizeCount }}份</p>
        <p>奖品抽完后，活动自动结束！</p>
      </div>
      <div class="tips flex justify-center align-center" style="margin-top: 50px;">
        <el-button class="btn" @click="CreateDialogConfirm">确定</el-button>
      </div>
    </template>
  </el-dialog>
  <el-dialog
  :visible.sync="dialogVisible" 
    title="公众号授权"
    width="30%"
  >
    <template #default>
      <div style="text-align: center;">
        <span>您还未授权公众号，请至手机端授权后操作</span>
        <img src="@/assets/image/code.jpg" alt="" class="codeImg" style="margin-top: 50px;" />
      </div>
    </template>
  </el-dialog>

  <el-dialog
  :visible.sync="dialogVIPVisible"
    title="VIP会员"
    width="900px"
  >
    <template #default>
      <div style="text-align: center;">
          <div class="vip_txt" v-if="mc.order_id">已开通会员权利，到期时间：{{mc.end_time}}</div>
          <div class="vip_txt" v-else>您还不是会员，企业版需开通会员才能发起活动。</div>
          <!-- vip_cards -->
          <div class="vip_cards">
          <div class="card" :class="payBox.payIndex == index ?'active':''" v-for="(item,index) in versionList" 
          @click="checkPayBox(item.version_id,item.amount,item.upper_limit,item.title,index)">
            <div class="name"><span class="big">{{item.title}}</span>/{{item.content[0]}}</div>
            <div class="noney"><span class="big">￥</span>{{item.amount/100}}</div>
            <div class="oldmony"  v-if="item.title == '年卡'">原价：{{item.sub_title}}元</div>
            <div class="oldmony"  v-else-if="item.title == '月卡'">折合：{{item.sub_title}}元</div>
            <div class="oldmony"  v-else></div>
            <div class="tj" v-if="item.title == '年卡'">超值推荐</div>
            <div class="tj no" v-else></div>
          </div>
        </div>
        <div class="buy_btn" @click="gopay" v-if="mc.order_id"><span>{{payBox.title}}续费,</span><span class="small">￥</span> <span class="big">{{payBox.fee/100}}元</span></div>
          <div class="buy_btn" @click="gopay" v-else><span>点击购买{{payBox.title}},</span><span class="small">￥</span> <span class="big">{{payBox.fee/100}}元</span></div>
          <div class="payTips" v-if="mc.order_id"><span class="red">*</span> 您已开通会员，若多次购买，将自动延长会员有效期。</div>
        <!-- vip_cards -->
      </div>
    </template>
  </el-dialog>
  <el-dialog  :visible.sync="showPayDialog" title="会员购买" width="370px" @close="payCloseHander">
    <template #default>
      <div class="qr-code">
        <div class="header">支付</div>
        <div class="subtitle">
          {{
            `购买${payBox.title}，需要支付${
              ((payBox.fee - 0 )/100)
            }元`
          }}
        </div>
        <vue-qr ref="Qrcode" :text="payQrcode" :margin="0" colorDark="#333333" colorLight="#ffffff" :logoSrc="icon"
              :logoScale="0.2" :size="160"></vue-qr>
        <!-- <qrcode :value="payQrcode" size="160"></qrcode> -->
        <!-- <div class="tips flex justify-center align-center">
          <img src="@/assets/image/icons/wx.png" alt="" />
          <p>使用微信扫码付款</p>
        </div> -->
      </div>
    </template>
  </el-dialog>
  <LoginBox ref="login"></LoginBox>
  </div>
</template>
<script>
import { getDzpSkinList, uploadImg, baseUrl, createLottery, getLotteryDetail, getDZPVersion, getDZPBuy,postDZPOrder ,getDZPOrder, getGzhList  } from '../api/api'
import LoginBox from './loginBox.vue'
import CommonHeader from './header.vue'
import { toChinesNum, formatTime2} from '@/utils/index.js'
import ImageCropperModal from '@/components/commons/imageCropper/index'
import VueQr from 'vue-qr'
import icon from '../assets/image/icons/wx.png'
export default {
  name: 'create',
  data() {
    return {
      icon: icon,
      lottery_id: '',
      version_id: '3',
      setp: 1,
      packUp: false,
      expand: false,
      lottery_type: 1,
      skinList: [],
      skin_id: 0,
      gzhList: [],
      prize_img: [],
      organizer: '',
      live_desc: '',
      prize_desc: '',
      show_prize_num: 1,
      isadvanced: '1', // string必须开启高级功能
      hidden_win: 0, // 0/1  用于标记是否隐藏中奖记录
      must_phone: 0, // 是否必须手机号参与手机
      is_join: 1, // string必须 自己是否参与
      is_share: 0, // string必须参与人能否分享
      is_gzh_fans: 0, //
      gzh_keyword: '',
      gzh_appid: '',
      join_num: 1,
      is_repeat_win: 0,
      daily_upper: 1,
      copy_title: '',
      copy_desc: '',
      is_multi: 0,
      is_wechat: 2,
      list: [{
        num: 1, // 数量
        desc: '', // string描述
        cover: '', // 奖项图片
        sort: '', // 排序
        weight: 1, // 中奖系数
        name: '一等奖',
        title: '奖项1', // 奖项名称
        type: '0', // 是否空奖
        lottery_detail_id: '', // 奖项id
        create_time: '',
        hasnum: '0',
        id: '',
        lottery_id: '',
        path: null,
        prize: [],
        prize_attr: null,
        prize_type: null,
        status: '1',
        uid: '',
        update_time: '',
        addr_remark: '',
        prize_end_time: '',

        get_prize_qrcode: '',
        get_prize_wechat: '',
        get_prize_phone: '',

        get_prize: 1,
        TempAppid: '',
        TempPath: ''
      },
      {
        num: 1,
        desc: '空奖项，抽中即为未中奖',
        cover: '', // 奖项图片
        sort: '', // 排序
        weight: 1, // 中奖系数
        name: '谢谢参与',
        title: '谢谢参与', // 奖项名称
        type: '1', // 是否空奖
        lottery_detail_id: '', // 奖项id
        create_time: '',
        hasnum: '0',
        id: '',
        lottery_id: '',
        path: null,
        prize: [],
        prize_attr: null,
        prize_type: null,
        status: '1',
        uid: '',
        update_time: '',
        addr_remark: '',
        prize_end_time: '',

        get_prize_qrcode: '',
        get_prize_wechat: '',
        get_prize_phone: '',

        get_prize: 1,
        TempAppid: '',
        TempPath: ''
      }],
      editableTabsValue: '奖项1',
      baseRules: {
        name: [
          {
            required: true,
            message: '请输入奖项名称'
          }
        ],
        desc: [
          {
            required: true,
            message: '请输入奖品名称'
          }
        ],
        num: [
          {
            required: true,
            message: '请输入奖品份数'
          }
        ]
      },
      msg: {
        weight: '发起人可设置中奖倍数来调整实时中奖概率，中奖倍数从0到10，倍数越高中奖率越高，倍数越低中奖率越低',
        gailv: '实时中奖概率会随着剩余奖品份数的变化而实时变化；其中，实时中奖概率= （剩余奖品份数*倍数）/ 奖品总数量； 其中，奖品总数量 =（奖项一的剩余奖品份数*倍数）+（奖项二的剩余奖品份数*倍数）+... （奖品N的剩余份数*倍数）',
        multi: '开启后，该抽奖活动可以生成多个参与码，参与人必须凭借参与码才能参与活动，一个参与码可设置不同的抽奖次数，参与码次数使用完后该参与码立即失效。\n\n 发起人可以生成1个2次抽奖次数的参与码给A用户（A获得2次抽奖次数），发起人可以生成1个3次抽奖次数的参与码给B用户（B获得3次抽奖次数），依次类推，多码模式更适合私密抽奖场景"。\n\n多码模式可以指定参与人获得不同的抽奖次数。多码模式系统会默认开启允许一人多次中奖，最多支持99次。开启多码模式后，如有人参与抽奖，则无法切换至单码抽奖模式。',
        wechat: '开启后，发起人只能通过分享到微信群邀请参与人，并且参与人必须在群内才能参与成功。',
        organizer: '抽奖发起人将显示在活动页，可填写企业名称、商家名称、或者活动举办方等。',
        phone: '发起人手机号为核实抽奖活动信息之用。',
        show_prize_num: '默认向参与人显示奖品份数，可选择隐藏',
        hidden_win: '默认向参与人显示滚动中奖记录，可选择隐藏',
        must_phone: '开启后，需授权手机号才能参与抽奖。',
        is_join: '开启后，发起人可参与抽奖',
        is_share: '开启后，参与人可将抽奖分享给其好友，有利于活动的传播。',
        is_gzh_fans: '开启后，参与人必须关注公众号回复关键词才能获取抽奖资格。特殊场景限制:多码模式，仅限群内抽奖，开启裂变等不支持开启公众号粉丝抽奖。',
        join_num: '默认当参与人中奖后，便不再重复参与抽奖。',
        is_repeat_win: '开启后，参与人可重复中奖。',
        daily_upper:
          '参与人有机会每日参与抽奖，每人每日可抽奖次数不能大于每人可抽奖次数,0代表不受限制。',
        vip:'纯净显示功能（VIP会员专属）!抽奖传播过程中，无平台推荐信息，无微信流量主广告，微信封面（开屏）广告除外。',
        copy_title:
          '“一键复制”可以增加您主要信息的传播度。比如：标题处填写“请加微信”，将微信号填写到被复制的内容区域，对方可通过”一键复制“来方便地找到您。',
		show_user_num:'默认显示参与人数，可设置隐藏。',
		show_prize:'默认向参与人显示奖品，可选择隐藏,仅支持扭蛋机，摇一摇，盲盒，砸金蛋。' ,
		show_win_list:'默认不允许参与人查看中奖名单,开启后，参与人也可以查看中奖名单。',
		is_subscribe:'默认开启订阅消息，开启后，参与人参与活动时，会询问是否订阅发起人，订阅成功过后，发起人发起新活动后，可以发通知给老用户，快速召回老用户参加活动。可设置关闭，关闭后，参与人在参与时不会出现订阅提示框，但仍然可以手动去订阅发起人。',
		is_anonymous:'默认新用户需要授权微信头像微信昵称，登录后才能参与。开启后，新用户自动匿名登录参与抽奖，有效减少新用户参与抽奖的前置步骤。参与抽奖后，可以进入“我的”手动更新个人资料，也可以不更新。不影响实际兑奖，兑奖请依据中奖码或者核销码作为唯一兑奖凭证。',
		password:'参与者在参与抽奖的时候，需要输入口令，口令正确才能参与抽奖。',
		apoint_address:'默认不限定可参与区域，可设置允许参与抽奖的区域。请移步手机端配置',
		is_write:'默认不需要填写信息即可参与，发起人开启后，参与者需填写信息后才能参加。请移步手机的配置',
		is_fission:'开启后，邀请好友获得抽奖机会。特殊场景限制:多码模式、公众号粉丝抽奖、仅限群内抽奖等不支持开启裂变',
		friend_num:'每邀请多少人增加一次总抽奖次数。。注：如设置每人每日抽奖次数限制，增加的抽奖次数需要隔日才可以使用。',
      },
      autoCropWidth: '400', // 要裁剪的宽
      autoCropHeight: '400', // 要裁剪的高
      file: '',
      fileName: '', // 存放文件名
      cropperVisible: false, // 控制弹窗打开关闭
      selectImgID: '',
      hasEmptyReward: true,
      ticketWay: [
        { value: '按收货地址发货' ,disabled:false},
        { value: '让中奖者联系我',disabled:false },
        { value: '扫码核销兑奖' ,disabled:false},
        { value: '跳转小程序领取' ,disabled:false},
		{ value: '去门店领取（移步小程序端设置）' ,disabled:true}
      ],
      token: '',
      actionUrl: baseUrl + 'file.html',
      apoint_address: 2, //是否指定地点 1指定地点 2非指定地点
      apoint_detail: {
        value: ['全部', '全部', '全部'],
        code: []
      },
      dialogVisible: false,
      showCreateDialog: false,
      totalCount: 0,
      totalPrizeCount:0,
      isRenew: false,
      is_write: 2,//是否需要填写信息   1 需要 2不需要
      write_content: [{ "name": "姓名", "key": "realname", "select": false, "must": false }, { "name": "手机号", "key": "phone", "select": false, "must": false }, { "name": "单位", "key": "depart_name", "select": false, "must": false }, { "name": "行业", "key": "company_name", "select": false, "must": false },{ "name": "自定义", "key": "note", "select": false, "must": false }, { "name": "图片", "key": "image", "select": false, "must": false }],//填写信息选择
      shop_id:[], // 选择门店

      is_develop:2, //是否开启开发者
      develop_url:'', //事件接受url
      develop_token:'', //事件接受token
      develop_test:2, // 2未 1通
      allPrizeNum:2,
      mc: '',
      payBox: {
        show: false,
        payIndex: 0
      },
      versionList: [],
      dialogVIPVisible: false,
      vip_advanced: 1,
      showPayDialog: false,
      payQrcode: '',
      payTimer: '',
      headers: {
        'x-token': ''
      },
      showAlert1: true,
	  show_user_num:1, //显示参与人数
	  show_prize:1, //显示奖品，仅支持 扭蛋机，摇一摇，盲盒，砸金蛋
	  show_win_list:2, //是否允许参与人查看中奖名单
	  is_subscribe:1, //开启订阅
	  is_show_join_num:1,
	  is_anonymous:0, //是否允许匿名登录参与抽奖
	  apoint_address: 2, //是否指定地点 1指定地点 2非指定地点 
	  apoint_detail: {
	    value: ['全部', '全部', '全部'],
	    code: [],
	  },
	  password:'',
	  is_fission: 0, //是否开启好友助力
	  friend_num: 1, //多少好友兑换一次抽奖机会
	

    }
  },
  components: {
    LoginBox,
    CommonHeader,
    ImageCropperModal,
    VueQr
  },
  methods: {
    hideAlert1() {
      this.$cookie.setCookie('hideAlert1', 1)
    },
    payCloseHander() {
      clearInterval(this.payTimer)
    },
    gopay() {
      postDZPOrder({version_id: this.payBox.id, trade_type: 'NATIVE'}, this.$cookie.getCookie('token')).then(res => {
        if (res.code == 200) {
        
          this.payQrcode = res.data.code_url
          this.showPayDialog = true
          this.checkOrder(res.data.order_id)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    checkOrder(id) {
      this.payTimer = setInterval(() => {
        getDZPOrder({ order_id: id }, this.$cookie.getCookie('token')).then(res => {
       
          if (res.data.code == 200 && res.data.data.status == 1) {
            this.$message.success('购买成功')
            this.showPayDialog = false
            this.dialogVIPVisible = false
            this.payCloseHander()
            this.fetchDZPBuy()
          }
        })
      }, 1000)
    },
    checkPayBox(versionid, amount, upperlimit, title, index) {
      this.payBox.id = versionid
      this.payBox.fee = amount
      this.payBox.upper_limit = upperlimit
      this.payBox.title = title
      this.payBox.payIndex = index
    },
    fnAllPrizeNum() {
      var allPrizeNum = 0
      this.list.forEach((v, i) => {
        if (v.hasnum && v.hasnum != '0') {
          allPrizeNum = (allPrizeNum - 0) + (v.num - v.hasnum) * v.weight
        } else {
          allPrizeNum = (allPrizeNum - 0) + v.num * v.weight
        }
      })
      this.allPrizeNum = allPrizeNum
    },
    vipChange(e) {
    
      if (this.mc && this.mc.order_id) {
        this.vip_advanced = e
      } else {
        setTimeout(() => {
          this.vip_advanced = 0
          this.dialogVIPVisible = true
        }, 500)
        this.$message.error('请先开启会员')
      }
    },
    multiChange(e){
      if(this.is_wechat == 1){
        this.$message.error('开启仅限群内参与，无法开启多码私密模式');
        setTimeout(() => {  
          this.is_multi = 0;
        }, 50);
        return false;
      }
      if(this.is_gzh_fans == 1){
        this.$message.error('开启公众粉丝参与，无法开启多码私密模式');
        setTimeout(() => {  
          this.is_multi = 0;
        }, 50);
        return false;
      }
	  if(this.is_fission == 1){
	    this.$message.error('开启裂变功能，无法开启多码私密模式');
	    setTimeout(() => {  
	      this.is_multi = 0;
	    }, 50);
	    return false;
	  }
      console.log(e)
      this.is_multi = e
      if(this.is_multi == 1){
        this.$confirm('开启私密（多码）模式后，该抽奖活动可以生成多个参与码，参与人必须凭借参与码才能参与活动，一个参与码对应N次抽奖机会（生成参与码时可配置抽奖次数），参与码次数使用完后，该参与码立即失效。 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

            this.is_multi = 1
            this.join_num= 99
            this.is_repeat_win= 1
            this.daily_upper= 99
            this.is_fission= 0
            this.friend_num= 0
            this.is_share = 0

        }).catch(() => {
          this.is_multi =  0
          this.join_num = 1
          this.is_repeat_win = 0
          this.daily_upper = 1
          this.is_fission = 0
          this.friend_num = 0
          this.is_share = 0
        });
      }
      else{
        this.is_multi = 0
        this.join_num = 1
        this.is_repeat_win = 0
        this.daily_upper = 1
        this.is_fission = 0
        this.friend_num = 0
      }
    },
    wechatChange(e){
      if(this.is_multi == 1){
        this.$message.error('无法开启仅限微信群内参与,请关闭多码私密模式后再试！');
        this.is_wechat = 2
        return false;
    }
    if(this.is_gzh_fans == 1){
      this.$message.error('开启无法开启仅限微信群内参与，请关闭公众号粉丝参与后再试！');
      this.is_wechat = 2
      return false;
    }
	if(this.is_fission ==1){
		this.$message.error('无法开启仅限微信群内参与，请关闭裂变功能后再试！');
		this.is_wechat = 2
		return false;
	}
    console.log(e)
    this.is_wechat = e
    },
    gzhChange(e){
      if(this.is_wechat == 1){
        this.$message.error('无法开启公众号粉丝参与，请关闭仅限群内参与后再试！');
        
        this.is_gzh_fans = 0
       
        return false;
      }
	  if(this.is_fission == 1){
	    this.$message.error('无法开启公众号粉丝参与，请关闭裂变功能后再试！');
	   
	    this.is_gzh_fans = 0
	   
	    return false;
	  }
	  if(this.is_multi == 1){
	    this.$message.error('无法开启公众号粉丝参与，请关闭多玛私密模式后再试！');
	   
	    this.is_gzh_fans = 0
	    
	    return false;
	  }
        console.log(e)
        this.is_gzh_fans = e
    },
	isFissionChange(e){
		
		if(this.is_wechat == 1){
		  this.$message.error('无法开启裂变功能，请关闭仅限群内参与后再试！');
		 
		  this.is_fission = 0
		
		  return false;
		}
		if(this.is_gzh_fans == 1){
		  this.$message.error('无法开启裂变功能，请关闭公众号粉丝参与后再试！');
		 
		  this.is_fission = 0
		
		  return false;
		}
		if(this.is_multi == 1){
		  this.$message.error('无法开启裂变功能，请关闭多玛私密模式后再试');
		 
		  this.is_fission = 0
		
		  return false;
		}
		
		console.log(e)
		this.is_fission = e
		if(this.is_fission == 1){
			 this.$message.success('开启裂变，默认开启允许重复中奖，并且不限制每日可抽奖次数，允许手动调整每日可抽奖次数。')
				this.is_repeat_win = 1;
				this.daily_upper = 0;
			}
			if(this.is_fission == 0){
				this.is_repeat_win = 0;
				this.daily_upper = this.join_num;
			}
		
	},
    dailtUpperInput(e) {
      let cur = Number(e)
      if (!cur) {
        this.daily_upper = 0
        return
      }

      if (cur > this.join_num) {
        this.$message.error('每人每日可抽奖次数不能大于每人可抽奖次数')
        this.$nextTick(() => {
          this.daily_upper = this.join_num
        })
        return
      }
      if (cur < 0) {
        this.$message.error('每人每日可抽奖次数不能小于0')
        this.$nextTick(() => {
          this.daily_upper = this.join_num
        })
        return
      }
      this.daily_upper = cur
    },
    joinNumInput(cur) {
      if (isNaN(cur)) {
        cur = this.onlyNumber(cur)
      }
      if (!cur || cur === 1) {
        this.join_num = 1
        this.daily_upper = 1
		if(this.is_fission != 1){
			this.is_repeat_win = 0
		}
        
        return
      }
      if (cur > 99 || cur < 0) {
        this.$message.error('每人可抽奖范围为0-99')
        this.$nextTick(() => {
          this.join_num = this.daily_upper
        })
      } else if (cur < this.daily_upper) {
        this.$message.error('每人可抽奖不能小于每人每日可抽奖次数')
        this.join_num = this.daily_upper
        this.$nextTick(() => {
          this.join_num = this.daily_upper
        })
        return
      }
      this.join_num = cur
    },
    toExample() {
      window.open('https://mp.weixin.qq.com/s/3ds0qfJc5_yAqTnh4GO7Og')
    },
    uploadPrizeImg({ code, data }) {
      if (code === 200) {
        this.prize_img.push(data.imgurl)
      }
    },
    uploadQrcode({ code, data }) {
      if (code === 200) {
        let changeDetail = this.list.filter(
          (e) => e.title === this.editableTabsValue
        )[0]
        changeDetail.get_prize_qrcode = data.imgurl
      }
    },
    /**
     * 限制输入数字
     */
    onlyNumber(e) {
      return Number(e.replace(/[^\d]/g, ""))
    },
    /**
     * 校验奖品份数
     */
    validRewardNum(num, item) {
      return new Promise((resolve) => {
        let totalNum = this.list.reduce(
          (total, cur) => (total += Number(cur.num)),
          0 - item.num
        )
        let curNum = this.list.reduce(
          (total, cur) => (total += Number(cur.num)),
          Number(num) - item.num
        )
        if (num < 1) {
          resolve(false)
        }
        if (num < item.prize.length && item.prize.length) {
          this.$message.error(`无法减少，已有${item.prize.length}人抽中该奖`)
          resolve(false)
        }
        if (curNum >= 60000) {
          this.$message.error(`奖品最多60000份`)
          this.$nextTick(() => {
            item.num = 60000 - totalNum
          })
          resolve(false)
        }
        resolve(true)
      })
    },
    weightChange(num, item) {
      this.list = this.list
      this.fnAllPrizeNum()
    },
    /**
     * 奖品份数输入
     */
    async rewardNumInput(num, item) {
      if (await this.validRewardNum(num, item)) {
        item.num = num
      }
      this.list = this.list
      this.fnAllPrizeNum()
    },
    uploadBtn(index) {
      this.selectImgID = index
    },
    // 文件状态改变时
    changeUpload(file, index) {
      var img = file.name.substring(file.name.lastIndexOf('.') + 1)
       const suffix = img === 'jpg' ||  img === 'JPG' ||  img === 'png'  ||  img === 'PNG' || img === 'jpeg' ||  img === 'JPEG' 
      if (!suffix) {
        this.$message.error('只能上传图片！')
        return false
      }
      // URL.createObjectURL的参数只能是blob或者file类型
      // 第一种方法用FileReader，URL.createObjectURL接收blob类型
      const reader = new FileReader()
      reader.onload = () => {
        // 把Array Buffer转化为blob 如果是base64不需要
        this.file = typeof reader.result === 'object' ? window.URL.createObjectURL(new Blob([reader.result]))
          : reader.result
      }
      // 转化为base64
      this.cropperVisible = true
      reader.readAsArrayBuffer(file.raw)
      // 第二种方法，URL.createObjectURL接收file类型
      // this.$nextTick(() => {
      //   this.file = URL.createObjectURL(file.raw)
      //   this.cropperVisible = true
      // })
      this.fileName = file.name
    },
    // 点击剪裁弹框的确定按钮
    async onConfirm(blob) {
      // 这里的new FormData（）指，以文件的方式传给后端（FormData的数据）
      const form = new FormData()
      // new File()的第一个参数是一个字符串数组，数组中的每一个元素对应着文件中一行的内容
      // 第二个参数就是文件名字符串
      // 第三个参数可以设定一些文件的属性，比如文件的MIME，最后更新时间等
      const file = new File([blob], this.fileName, { type: blob.type, lastModified: Date.now() })
      file.uid = Date.now()
      form.append('file', file)
      // 如果想在这里打印查看form的值，会发现它是空对象
      // 解决办法，需要用form.get('键')的方法获取值
      // console.log(form.get('file'))
      // 这里调用接口，获取后端返给的图片地址
      const { data } = await uploadImg(form)
      this.list[this.selectImgID].cover = data.imgurl
      this.cropperVisible = false
    },
    addEmpty() {
      this.list.push({
        num: 1, // 数量
        desc: '空奖项，抽中即为未中奖',
        cover: '',
        sort: '',
        weight: '1',
        title: '谢谢参与',
        name: '谢谢参与',
        type: '1',
        lottery_detail_id: '',
        create_time: '',
        hasnum: '0',
        id: '',
        lottery_id: '',
        path: null,
        prize: [],
        prize_attr: null,
        prize_type: null,
        status: '1',
        uid: '',
        update_time: '',
        addr_remark: '',
        prize_end_time: '',

        get_prize_qrcode: '',
        get_prize_wechat: '',
        get_prize_phone: '',

        get_prize: 1,
        TempAppid: '',
        TempPath: ''
      })
      this.editableTabsValue = this.list[this.list.length - 1].title
      this.hasEmptyReward = true
    },
    tabAdd(e, action) {
      if (this.lottery_type === 2) {
        this.$message.error('九宫格不能添加奖项')
        return false
      }
      if (this.lottery_type === 1) {
        if (this.list.length >= 12) {
          this.$message.error('最多不能超过12个奖项')
          return false
        }
      }
      if (this.lottery_type === 3 || this.lottery_type === 4) {
        if (this.list.length >= 20) {
          this.$message.error('最多不能超过20个奖项')
          return false
        }
      }
      const totalAmount =
        this.list.reduce((sum, cur) => sum + Number(cur.num), 0) + 1
      if (totalAmount > 60000) {
        this.$message.error('最多不能超过60000个奖项')
        return false
      }
      if (this.hasEmptyReward) {
        const index = this.hasEmptyReward ? 0 : 1
        this.list.splice(this.list.length - 1, 0, {
          num: 1, // 数量
          desc: '', // string描述
          cover: '', // 奖项图片
          sort: '', // 排序
          weight: 1, // 中奖系数
          name: `${toChinesNum(this.list.length + index)}等奖`,
          title: `奖项${this.list.length + index}`, // 奖项名称
          type: '0', // 是否空奖
          lottery_detail_id: '', // 奖项id
          create_time: '',
          hasnum: '0',
          id: '',
          lottery_id: '',
          path: null,
          prize: [],
          prize_attr: null,
          prize_type: null,
          status: '1',
          uid: '',
          update_time: '',
          addr_remark: '',
          prize_end_time: '',

          get_prize_qrcode: '',
          get_prize_wechat: '',
          get_prize_phone: '',

          get_prize: 1,
          TempAppid: '',
          TempPath: ''
        })
        this.editableTabsValue = this.list[this.list.length - 2].title
      } else {
        this.list.push({
          num: 1, // 数量
          desc: '', // string	描述
          cover: '', // 奖项图片
          sort: '', // 排序
          weight: 1, // 中奖系数
          name: `${toChinesNum(this.list.length + 1)}等奖`,
          title: `奖项${this.list.length + 1}`, // 奖项名称
          type: '0', // 是否空奖˝©
          lottery_detail_id: '', // 奖项id
          create_time: '',
          hasnum: '0',
          id: '',
          lottery_id: '',
          path: null,
          prize: [],
          prize_attr: null,
          prize_type: null,
          status: '1',
          uid: '',
          update_time: '',
          addr_remark: '',
          prize_end_time: '',

          get_prize_qrcode: '',
          get_prize_wechat: '',
          get_prize_phone: '',
          get_prize: 1,
          TempAppid: '',
          TempPath: ''
        })
        this.editableTabsValue = this.list[this.list.length - 1].title
      }
      this.fnAllPrizeNum()
      this.$message({message: '添加成功', type: 'success'})
    },
    tabRemove(e) {
      if (this.lottery_type === '3') {
        this.$message.error('九宫格不能删除奖项')
        return false
      }
      if (this.list.length === 2) {
        this.$message.error('最少需要2个奖项')
        return false
      }
      const deleteDetail = this.list.filter((reward) => reward.title === e)[0]
      console.log(deleteDetail)
      if (deleteDetail.prize.length) {
        this.$message.error('该奖项已经有人中奖，无法删除')
        return false
      }
      if (e === '谢谢参与') {
        this.hasEmptyReward = false
      }
      this.editableTabsValue = '奖项1'
      const newList = this.list.filter((item) => e !== item.title)
      newList.forEach((item, index) => {
        if (item.type === '0') {
          Object.assign(item, {
            title: `奖项${index + 1}`// 奖项名称
          })
        }
      })
      this.list.splice(0, this.list.length, ...newList)
      this.$message({message: '移除成功', type: 'success'})
      this.fnAllPrizeNum()
    },
    imageUpload() { },
    fetchSkinList() {
      getDzpSkinList({}, this.$cookie.getCookie('token')).then((res) => {
        if (res.data.code === 200) {
          this.skinList = res.data.data
        } else {

        }
      })
    },
    setDIY() {
      this.$router.push('/diy')
    },
    selectSkin(e) {
      this.skin_id = e
    },
    selectPlay(e) {
      this.lottery_type = e
    },
    next() {

      if (this.setp >= 4) {
        return false
      } else {
        this.setp++
      }
      if (this.setp === 3) {
        // 判断lottery_type 并配置对应的奖项数量
        if (this.lottery_id === '') {
          // 如果新创建，九宫格默认8个奖项 一个谢谢参与奖项
          if (this.lottery_type === 2) {
            if (this.list.length !== 8) {
              this.list.length = 0
              for (var i = 0; i < 7; i++) {
                this.list.push({
                  num: 1, // 数量
                  desc: '', // string描述
                  cover: '', // 奖项图片
                  sort: '', // 排序
                  weight:1, // 中奖系数
                  name: `${toChinesNum(i + 1)}等奖`,
                  title: '奖项' + (i + 1),
                  type: '0', // 是否空奖
                  lottery_detail_id: '', // 奖项id
                  create_time: '',
                  hasnum: '0',
                  id: '',
                  lottery_id: '',
                  path: null,
                  prize: [],
                  prize_attr: null,
                  prize_type: null,
                  status: '1',
                  uid: '',
                  update_time: '',
                  addr_remark: '',
                  prize_end_time: '',

                  get_prize_qrcode: '',
                  get_prize_wechat: '',
                  get_prize_phone: '',

                  get_prize: 1,
                  TempAppid: '',
                  TempPath: ''
                })
              }
              this.list.push({
                num: 1,
                desc: '空奖项，抽中即为未中奖',
                cover: '', // 奖项图片
                sort: '', // 排序
                weight:1, // 中奖系数
                name: `谢谢参与`,
                title: '谢谢参与',
                type: '1', // 是否空奖
                lottery_detail_id: '', // 奖项id
                create_time: '',
                hasnum: '0',
                id: '',
                lottery_id: '',
                path: null,
                prize: [],
                prize_attr: null,
                prize_type: null,
                status: '1',
                uid: '',
                update_time: '',
                addr_remark: '',
                prize_end_time: '',

                get_prize_qrcode: '',
                get_prize_wechat: '',
                get_prize_phone: '',

                get_prize: 1,
                TempAppid: '',
                TempPath: ''
              })
            }
          } else if (this.lottery_type === 3 || this.lottery_type === 1 || this.lottery_type === 4) {
            this.list = []
            this.list.push({
              num: 1, // 数量
              desc: '', // string描述
              cover: '', // 奖项图片
              sort: '', // 排序
              weight: 1, // 中奖系数
              name: `一等奖`,
              title: '奖项1',
              type: '0', // 是否空奖
              lottery_detail_id: '', // 奖项id
              create_time: '',
              hasnum: '0',
              id: '',
              lottery_id: '',
              path: null,
              prize: [],
              prize_attr: null,
              prize_type: null,
              status: '1',
              uid: '',
              update_time: '',
              addr_remark: '',
              prize_end_time: '',

              get_prize_qrcode: '',
              get_prize_wechat: '',
              get_prize_phone: '',

              get_prize: 1,
              TempAppid: '',
              TempPath: ''
            })
            this.list.push({
              num: 1,
              desc: '空奖项，抽中即为未中奖',
              cover: '', // 奖项图片
              sort: '', // 排序
              weight: 1, // 中奖系数
              name: `谢谢参与`,
              title: '谢谢参与',
              type: '1', // 是否空奖
              lottery_detail_id: '', // 奖项id
              create_time: '',
              hasnum: '0',
              id: '',
              lottery_id: '',
              path: null,
              prize: [],
              prize_attr: null,
              prize_type: null,
              status: '1',
              uid: '',
              update_time: '',
              addr_remark: '',
              prize_end_time: '',

              get_prize_qrcode: '',
              get_prize_wechat: '',
              get_prize_phone: '',

              get_prize: 1,
              TempAppid: '',
              TempPath: ''
            })
          }
        }
      }
      if (this.setp === 4) {
        // 判断基础信息，如果不正确，则返回第三步
        let hasNull = []
        let hasWrongConcat = []
        let hasWrongWrongApp = []
        let noWeight = 0
        let isPass = false
        this.list.forEach((e) => {
          const { num, desc, weight, name, get_prize, get_prize_wechat, get_prize_phone, get_prize_qrcode, TempAppid,TempPath } = e
          if (!num || !desc || !name) {
            hasNull.push(e.title)
          }
          if (weight != "0" && isPass == false) {
            noWeight = weight
            isPass = true
          }
          if (get_prize == 2 && ( get_prize_wechat == '' && get_prize_phone == '' && get_prize_qrcode == '')) {
            hasWrongConcat.push(e.title)
          }
          if (get_prize == 4 && ( TempAppid == '' || TempPath == '')) {
            hasWrongWrongApp.push(e.title)
          }
        })

        console.log(noWeight)
        if (noWeight == 0) {
          this.$alert('至少有一个奖项的中奖系数不为0', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          this.setp = 3
          return false
        }
        if (hasNull.length) {
          this.editableTabsValue = hasNull[0]
          this.$alert(`请完善${hasNull.join(',')}的信息`, {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          this.setp = 3
          return false
        }
        if (hasWrongConcat.length) {
          this.editableTabsValue = hasWrongConcat[0]
          this.$alert(`请完善${hasWrongConcat.join(',')}的兑奖方式：联系发起人信息`, {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          this.setp = 3
          return false
        }
        if (hasWrongWrongApp.length) {
          this.editableTabsValue = hasWrongWrongApp[0]
          this.$alert(`请完善${hasWrongWrongApp.join(',')}的兑奖方式：跳转小程序信息`, {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          this.setp = 3
          return false
        }
      }
    },
    prev() {
      if (this.setp <= 0) {
        return false
      } else {
        this.setp--
      }
    },
    toPackUp() {
      this.expand = this.packUp
      this.packUp = !this.packUp
    },
    create() {
      if (this.mc && this.mc.order_id) {
        
      } else {
        setTimeout(() => {
          this.dialogVIPVisible = true
        
        }, 500)
        this.$message.error('请先开启会员')
        return false
      }

      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].type == 0 && this.list[i].name == '谢谢参与') {
          this.$alert('奖项' + (i + 1) + '为非空奖项，非空奖项名称不能设置为“谢谢参与”，请修改奖项名称后后再保存', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
      }
      if (this.is_gzh_fans == 1) {
        if (this.gzh_appid == '') {
          this.$alert('公众号粉丝参与，需授权公众号', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
        if (this.gzh_keyword == '') {
          this.$alert('公众号粉丝参与，需设置关键字回复', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
      }
      if (this.is_develop == 1) {
        if (this.develop_url == '') {
          this.$alert('开启开发者模式必须填写事件接受URL', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
        if (this.develop_test == 2) {
          this.$alert('开启开发者模式，请先测试链接', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
      }
      if (this.is_write == 1) {
        var isFalse = false
        this.write_content.forEach((v, i) => {
          if (v.select == true) {
            isFalse = true
          }
        })
        if (isFalse == false) {
          this.$alert('请至少选择一个需要填写的信息', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
      }
      this.isCreate = true
      this.postList = JSON.parse(JSON.stringify(this.list))

      this.postList.forEach((v, i) => {
        if (v.TempAppid && v.TempPath) {
          var path = {}
          path.appid = v.TempAppid
          path.path = v.TempPath
          v.path = JSON.stringify(path)
        }
      })

      var data = {
        lottery_id: this.lottery_id, //抽奖索引id
        version_id: 3, //版本id
        order_id: this.order_id, //订单id
        get_prize: this.get_prize, //兑奖方式：1按收货地址发货，2联系发起人
        prize_end_time: this.prize_end_time,
        phone: this.createTel,
        is_advanced: this.isadvanced,
        show_prize_num: this.show_prize_num,
        show_prize: this.show_prize,
        is_repeat_win: this.is_repeat_win,
        is_join: this.is_join,
        is_share: this.is_share,
        join_num: this.join_num,
        organizer: this.organizer,
        get_prize_qrcode: this.get_prize_qrcode, //收将微信号
        get_prize_wechat: this.get_prize_wechat, //收将微信号
        get_prize_phone: this.get_prize_phone, //收奖联系电话
        addr_remark: this.addr_remark, //填写收货地址默认提示
        live_desc: this.live_desc, //抽奖介绍
        prize_desc: this.prize_desc, //奖品描述
        prize_img: this.prize_img.toString(), //奖品图片
        copy_title: this.copy_title,
        copy_desc: this.copy_desc,
        detail: this.postList,
        skin_id: this.skin_id,
        daily_upper: this.daily_upper,
        max_prize: this.max_prize,
        is_public: this.is_public,
        is_fission: this.is_fission,
        friend_num: this.friend_num,
        hidden_win: this.hidden_win,
        must_phone: this.must_phone,
        is_anonymous: this.is_anonymous,
        gzh_appid: this.gzh_appid,
        gzh_keyword: this.gzh_keyword,
        is_gzh_fans: this.is_gzh_fans,
        lottery_type: this.lottery_type,

        gzh_auth_id: this.auth_id,
        gzh_name: this.gzh_name,
        vip_advanced: this.vip_advanced,
        is_multi: this.is_multi,
        password: this.password,
        apoint_address: this.apoint_address,

        is_write: this.is_write,
        write_content: JSON.stringify(this.write_content),//填写信息选择
        shop_id: JSON.stringify(this.shop_id),
        is_develop: this.is_develop,
        develop_token: this.develop_token,
        develop_url: this.develop_url,
        v: 2,
        is_wechat: this.is_wechat,
		show_user_num:this.show_user_num,
		show_prize:this.show_prize,
		show_win_list:this.show_win_list,
		is_subscribe:this.is_subscribe,
      }
      data.apoint_detail = {
        value: '',
        code: ''
      }

      var copyObject = JSON.parse(JSON.stringify(this.apoint_detail))
      if (copyObject.value && copyObject.value.length > 0) {
        data.apoint_detail.value = copyObject.value.toString()
      }
      if (copyObject.code && copyObject.code.length > 0) {
        data.apoint_detail.code = copyObject.code.toString();
      }
      var prizeCount = this.totalRewardCount(this.list)
      this.totalPrizeCount = this.totalPrizeCountHander(this.list)
      this.totalCount = prizeCount
      if (prizeCount <= 0) {
        this.$alert('剩余可供抽取的奖品份数不能等于0', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        this.isCreate = false
        return false
      }
      console.log(data)
      createLottery(data, this.$cookie.getCookie('token')).then(
        (response) => {
          this.isCreate = false
          if (response.code === 200) {
            this.showCreateDialog = true
          } else if (response.code === 420) {
            this.$alert(response.msg, {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push('/list')
              }
            })
          } else {
            this.$alert(response.msg, {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
          }
        },
        (reject) => {
          this.isCreate = false
          this.$alert(reject.msg, {
            confirmButtonText: '确定',
            callback: action => {

            }
          })
        }
      )
      // const query = JSON.parse(JSON.stringify(lotteryQuery));
      // query.prize_img = lotteryQuery.prize_img.join(",");
      // const { code, data, msg } = await ajax.createLottery(query);
      // if (code === 200) {
      //   if (nomoreCreateDialog.value) {
      //     router.replace("/record");
      //   } else {
      //     showCreateDialog.value = true;
      //   }
      // } else if (code == 420) {
      //   ElMessageBox.alert(msg, "提示", {
      //     confirmButtonText: "确定",
      //     callback: (action) => {
      //       router.replace("/record");
      //     },
      //   });
      // } else {
      //   ElMessageBox.alert(msg, "提示", {
      //     confirmButtonText: "确定",
      //   });
      //   lotteryQuery.prize_img = lotteryQuery.prize_img.split(",");
      // }
    },
    totalRewardCount(list) {
      return list.reduce(function (sum, cur) {
        return (sum += Number((cur.num - (cur.hasnum || 0)) * cur.weight))
      }, 0)
    },
    totalPrizeCountHander(list) {
      return list.reduce(function (sum, cur) {
        return (sum += Number((cur.num - (cur.hasnum || 0)) * (cur.weight == 0?0:1)))
      }, 0)
    },
    back() {
      this.$router.back()
    },
    fetchData() {
      if (this.$cookie.getCookie('token')) {
        this.token = this.$cookie.getCookie('token')
        this.headers['x-token'] = this.$cookie.getCookie('token')
      }
    },
    /**
     *删除奖品图片
    */
    deletePrizeImg(item) {
      this.prize_img = this.prize_img.filter((e) => e !== item)
    },
    /**
     * 手机号输入
     */
    userPhoneInput(e) {
      this.phone = e ? this.onlyNumber(e) : e
    },
    /**
     *中奖联系方式手机号
    */
    prizePhoneInput(e) {
      let changeDetail = this.list.filter((e) => e.title === this.editableTabsValue)[0]
      changeDetail.get_prize_phone = this.onlyNumber(e) == 0 ? '' : this.onlyNumber(e)
    },
    /**
     *中奖联系方式微信号
    */
    prizeWechatInput(e) {
      if (/[\u4e00-\u9fa5]/.test(e)) {
        return
      }
      let changeDetail = this.list.filter((e) => e.title === this.editableTabsValue)[0]
      changeDetail.get_prize_wechat = e
    },
    /**
     *中奖联系方式手机号
    */
    prizeAppidInput(e) {

      let changeDetail = this.list.filter((e) => e.title === this.editableTabsValue)[0]
      changeDetail.TempAppid = e
    },
    prizeTempPathInput(e) {

      let changeDetail = this.list.filter((e) => e.title === this.editableTabsValue)[0]
      changeDetail.TempPath = e
    },
    // 展示创建码
    showCreate() {
      if (this.gzhList.length == 0) {
        console.log('展示创建码')
        this.dialogVisible = true
      }
    },
    CreateDialogConfirm() {
      this.$router.push('/list')
    },
    init(id, renew) {
  
      // skinVersion.value =
      //     Number(lotteryQuery.version_id) > 2 ? 'profession' : 'base'
      this.isRenew = renew
      if (id) {
        getLotteryDetail({lottery_id: id}, this.$cookie.getCookie('token')).then(res => {
   
          if (res.data.code === 200) {
            res.data.data.detail.forEach((e, index) => {
            e.title = e.type == 1 ? "谢谢参与" : `奖项${index + 1}`
            e.lottery_detail_id = e.id
            e.get_prize = Number(e.get_prize)
            e.prize_end_time = e.prize_end_time =='0' ? ' ': formatTime2(new Date(parseInt( e.prize_end_time +'000')))
            if (renew) {
              //复制抽奖
              delete e.id
              delete e.prize
              delete e.lottery_detail_id
              delete e.create_time
              delete e.update_time
              e.hasnum = 0
              e.lottery_id = ""
            }
          })
             
          this.lottery_id =  res.data.data.id //抽奖索引id
          if(renew){
            this.lottery_id = ''
          }
          this.version_id =  res.data.data.version_id //版本id
          this.order_id =  res.data.data.order_id //订单id

          this.prize_end_time =  res.data.data.prize_end_time == '0' ? '0' : formatTime2(new Date(parseInt( res.data.data.prize_end_time +'000')))
          this.createTel =  res.data.data.phone
          this.isadvanced =  res.data.data.is_advanced
 
        
          this.is_repeat_win =  res.data.data.is_repeat_win
          this.is_join =  res.data.data.is_join
          this.is_share =  res.data.data.is_share
          this.join_num =  res.data.data.join_num
          this.organizer =  res.data.data.organizer
          this.get_prize_qrcode =  res.data.data.get_prize_qrcode //收将微信号
          this.get_prize_wechat =  res.data.data.get_prize_wechat //收将微信号
          this.get_prize_phone =  res.data.data.get_prize_phone //收奖联系电话
          this.addr_remark =  res.data.data.addr_remark //填写收货地址默认提示
          this.live_desc =  res.data.data.live_desc //抽奖介绍
          this.prize_desc =  res.data.data.prize_desc //奖品描述

          this.copy_title =  res.data.data.copy_title
          this.copy_desc =  res.data.data.copy_desc

          this.skin_id =  res.data.data.skin_id
          this.diy_skin =  res.data.data.sponsordiy_skin || ''
          this.daily_upper =  res.data.data.daily_upper
          this.status =  res.data.data.status
          this.max_prize =  res.data.data.max_prize
          this.is_public =  res.data.data.is_public
          this.is_fission = Number(res.data.data.is_fission)
          this.friend_num =  Number(res.data.data.friend_num)
          this.is_anonymous = Number(res.data.data.is_anonymous)
          this.gzh_appid =  res.data.data.gzh_appid || ''
          this.gzh_auth_id = res.data.data.auth_id || '0'
          this.auth_id = res.data.data.auth_id || '0'
          this.gzh_keyword =  res.data.data.gzh_keyword || ''

          this.lottery_type = res.data.data.lottery_type
          this.vip_advanced = (res.data.data.vip_advanced - 0)  || 0
          this.gzh_name = res.data.data.gzh_name
          this.is_multi = res.data.data.is_multi || 0
          this.password = res.data.data.password || ''
          this.apoint_address =  res.data.data.apoint_address
          this.is_write =  res.data.data.is_write
          this.write_content =  (res.data.data.write_content != '' && res.data.data.write_content != null) ? JSON.parse(res.data.data.write_content) : this.write_content
          this.is_develop = res.data.data.is_develop
          this.develop_token = res.data.data.develop_token
          this.develop_url = res.data.data.develop_url
          this.is_wechat = res.data.data.is_wechat || 2
		  this.show_user_num = Number(res.data.data.show_user_num)
		  this.show_prize = Number(res.data.data.show_prize)
		  this.show_win_list = Number(res.data.data.show_win_list)
		  this.is_subscribe = Number(res.data.data.is_subscribe)
          // this.lottery_id = res.data.data.id
          this.get_prize = Number(res.data.data.get_prize)
          this.show_prize_num = Number(res.data.data.show_prize_num)
          this.hidden_win = Number(res.data.data.hidden_win)
          this.must_phone = Number(res.data.data.must_phone)
          this.is_join = Number(res.data.data.is_join)
          this.is_gzh_fans = Number(res.data.data.is_gzh_fans)
          this.is_repeat_win = Number(res.data.data.is_repeat_win)
          this.prize_img = res.data.data.prize_img ? res.data.data.prize_img.split(",") : []
          this.is_share = Number(res.data.data.is_share)
          this.skin_id = res.data.data.skin_id

          res.data.data.detail.forEach((v, i) => {
            if (v.path == '') {
              v.TempAppid = ''
              v.TempPath = ''
            } else {
              var path = JSON.parse(v.path)
              v.TempAppid = path.appid
              v.TempPath = path.path

            }
          })
          this.list = res.data.data.detail
           this.fnAllPrizeNum()
        }
        })
   
      }
    },
    fetchDZPVersion() {
      getDZPVersion({}, this.$cookie.getCookie('token')).then(res => {
        if(res.data.code == 200){
          this.versionList = res.data.data
          this.versionList.forEach((v,i) => {
            if(i==0){
              this.payBox.id = v.version_id
              this.payBox.fee = v.amount
              this.payBox.upper_limit =v.upper_limit
              this.payBox.title =v.title
              this.payBox.payIndex = 0
            }
           
          })
        }
      })
    },
    fetchDZPBuy() {
      getDZPBuy({}, this.$cookie.getCookie('token')).then(res => {
        if (res.data.code == 200) {
          this.mc =  res.data.data.vip
        }
      })
    },
    fetchGzhList() {
      getGzhList({}, this.$cookie.getCookie('token')).then(res => {
        if (res.data.code == 200) {
          debugger
          this.gzhList =  res.data.data
        }
      })
    },
  },
  created() {
    this.fetchSkinList()
    const {
      query: { id, version, renew = 0, order_id = "" },
    } = this.$route;
    this.order_id = order_id;
    this.version_id = 3;
    console.log(id)
    console.log('version========',this.version_id)
    if (id) {
      this.lottery_id = id
      this.setp = 2
    }
    this.init(id, renew)
    this.fetchDZPVersion()
    this.fetchDZPBuy()
    this.fetchGzhList()
  },
  destroyed() {
    this.payCloseHander()
  },
  mounted() {
    debugger
    if (this.$cookie.getCookie('hideAlert1') == '1') {
      this.showAlert1 = false
    }
    if (this.$cookie.getCookie('token') === '') {
      console.log(this.$cookie.getCookie('token'))
      this.$refs.login.login_fn()
    } else {
      this.token = this.$cookie.getCookie('token')
    }
  }
}
</script>
<style lang="scss">
.settings .el-tabs__new-tab{
  border: 2px solid #674eff;
  color:#674eff;
}

</style>
<style scoped lang="scss">
.setpBox {
  width: 1200px;
  margin: 20px auto;
  height: 100px;
  // position: relative;
  // left: 0;
  // right: 0;
  // top: 59px;
  // margin: 0 auto;
}

.setp1 {
  width: 1200px;
  margin: 20px auto;
  background: #ffffff;
  border-radius: 15px;
  padding: 30px 100px 130px;
  box-sizing: border-box;
  min-height: calc(100vh - 96px - 140px - 200px);
  position: relative;

  .lottery_type {
    font-size: 30px;
    font-weight: bold;
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
  }

  .setpItems {

    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;

    .setpItem {
      width: 210px;
      height: 165px;
      border: 4px solid #ffffff;
      background: #f5ddce;
      position: relative;
      border-radius: 10px;
      overflow: hidden;
      cursor: pointer;
      margin-bottom: 30px;

      &.active {
        border: 4px solid #67C23A;
        background: #67C23A;
        color: #ffffff;
        font-weight: bold;
        border-radius: 10px;
        overflow: hidden;

        .playName {
          color: #ffffff;
        }

        button {
          position: absolute;
          right: 5px;
          top: 5px;

        }
      }

      img {
        width: 210px;
        height: 135px;
      }

      .playName {
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #333;
      }
    }

    .setpItemSkin {
      width: 262px;
      height: 195px;
      border: 4px solid #ffffff;
      background: #f5ddce;
      position: relative;
      border-radius: 10px;
      overflow: hidden;
      cursor: pointer;
      margin-bottom: 30px;

      &.active {
        border: 4px solid #67C23A;
        background: #67C23A;
        color: #ffffff;
        font-weight: bold;
        border-radius: 10px;
        overflow: hidden;

        .playName {
          color: #ffffff;
        }

        button {
          position: absolute;
          right: 5px;
          top: 5px;

        }
      }

      img {
        width: 262px;
        height: 165px;
      }

      .playName {
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #333;
      }
    }

  }
}

.setpNextBox {
  position: fixed;
  left: 0;
  right: 0;
  height: 100px;
  margin: 0 auto;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.scroll {
  height: 100%;
  width: 750px;
  margin: 0 auto;
  overflow-y: auto;
  padding-bottom: 200px;

  .version,
  .reward {
    padding: 5px 20px;
    border-radius: 5px;
  }

  .version {
    background-color: #f5f7fb;
  }

  .reward {
    background-color: #674eff;
    color: #fff;
  }

  .arrow-right {
    width: 14px;
    height: 14px;
    padding: 0 20px;
  }

  .settings {
    padding-top: 20px;

    .reward-set {
      padding-top: 11px;

      p {
        font-weight: bold;
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
      }
    }
  }

  .higher-setting {
    margin-top: 56px;

    p {
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
      margin-bottom: 30px;
    }

    .input {
      width: 360px;
    }
  }
}

.reward-card {
  margin-top: 20px;

  .icon {
    width: 24px;
    height: 24px;
  }

  .upload {
    width: 360px;
    height: 120px;
    background-color: #fafafc;
    border: 1px solid #bbb;
    text-align: center;

    .upload-img-box {
      margin-bottom: 0;
      width: 80px;
      margin-top: 10px;
      height: 80px;

      .delete {}
    }

    img {
      width: 80px;
      height: 80px;
    }
  }

  .input {
    width: 360px;
  }

  .add {
    width: 140px;
  }
}

.pack-up {
  animation: packUp 0.5s linear forwards;
}

@keyframes packUp {
  from {
    left: 50%;
  }

  to {
    left: 100%;
  }
}

.expand {
  animation: expand 0.5s linear forwards;
}

@keyframes expand {
  from {
    left: 100%;
  }

  to {
    left: 50%;
  }
}

.left-expand {
  animation: lExpand 0.5s linear forwards;
}

@keyframes lExpand {
  from {
    right: 50%;
  }

  to {
    right: 0;
  }
}

.left-pack-up {
  animation: lPackUp 0.5s linear forwards;
}

@keyframes lPackUp {
  from {
    right: 0;
  }

  to {
    right: 50%;
  }
}

.reward-img-box {
  width: 360px;
  flex-wrap: wrap;
}

.upload-img-box {
  position: relative;
  width: 132px;
  height: 132px;
  margin-right: 10px;
  margin-bottom: 10px;

  .delete {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);

    .icon {
      width: 24px;
      height: 24px;
      color: #fff;
    }
  }

  &:hover {
    .delete {
      display: flex;
    }
  }
}

.upload-img {
  width: 132px;
  height: 132px;
  border: 1px solid #ccc;
  margin-right: 10px;
}

.tips {
  span {
    color: red;
  }
}

.cut-dialog {
  width: 425px;
  height: 425px;
  margin: 0 auto;
}

.btn {
  background-color: #674eff;
  color: #fff;
  // margin-top: 10px;
}

.tip-icon {
  width: 15px;
  height: 15px;
  margin-left: 8px;
  cursor: pointer;
}
.label-box {
  position: relative;
  .require {
    color: red;
    margin-right: 4px;
    position: absolute;
    top: 1px;
    left: -13px;
  }
}
:deep(.el-form-item__label) {
  display: flex;
  &::before {
    content: "\00A0\00A0";
    width: 16px;
  }
}
:deep(.el-tabs__new-tab) {
  .icon {
    color: #000;
    width: 14px;
    height: 14px;
  }
}
.add-empty {
  margin-left: 220px;
}

.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  border: 1px dashed #bbb;
  background-color: #fafafc;
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  text-align: center;
  .el-icon-plus {
    width: 20px;
    height: 20px;
  }
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.last-input {
  margin-top: 20px;
}
.copy-box {
  flex-direction: column;
}

.vip_cards{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding:10px 0px;
}
.vip_cards .card{
  width: 105px;

  border: 3px solid #eeeeee;
  border-radius: 7px;

  text-align: center;
  font-size: 12px;
  padding-top: 15px;
  box-sizing: border-box;
  overflow: hidden;
  margin: 0 10px;

}
.vip_cards .card.active{
  border: 3px solid #d18a33;
}
.vip_cards .card .name{
  font-size: 12px;
}
.vip_cards .card .name .big{
  font-size: 14px;
  font-weight: bold;
}
.vip_cards .card .noney{
  color: #d18a33;
  margin-top: 10px;
  font-size: 20px;


}
.vip_cards .card .noney .big{
  font-size: 12px;
}

.vip_cards .card .oldmony{
  margin-top: 10px;
  font-size: 11px;
  color: #dddddd;
  text-decoration:line-through;
  height: 15px;
  line-height:15px;
}

.vip_cards .card .tj{
  background: #d18a33;
  color: #3e2004;
  margin-top: 10px;
  height: 25px;
  line-height: 25px;

}
.vip_cards .card .tj.no{
  background: none;
}
.payTips{
  color: #999999;
  font-size: 12px;
}
.payTips .red{
  color: #f82602;
}
.buy_btn{
  width: 305px;
  margin:30px auto;
  background: #f82602;
  color: #ffffff;
  font-size:15px;
  text-align: center;
  height: 40px;
  line-height:40px;
  border-radius: 20px;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
}
.buy_btn.disable{
  background: #ececec;
  color: #999999;
  padding-right: 85px;
  font-size: 13px;
  border-radius: 5px;
}
.buy_btn.disable.ios{
  padding-right: 0;
}
.buy_btn .buy_btn_kf{
  width: 95px;
  height:40px;
  position: absolute;
  right: 0;
  top: 0;
  color: #ffffff;
  background: #000000;
  font-size: 15px;
  text-align: center;
  height:40px;
  line-height: 40px;
  border-radius: 10rpx;
  border-top-left-radius: 55px ;
  border-top-right-radius:55px ;
  font-size: 12px;
  padding-left: 10px;

}
.buy_btn .small{
  font-size: 11px;
}

.buy_btn .big{
  font-size: 15px;
  font-weight: bold;
}
.vip_txt{
  margin-bottom: 50px;
  font-size:18px;
  font-weight: bold;
}
.vip_txt2{
  margin-bottom: 20px;
  font-size:12px;
  color:#999999;
  font-weight: bold;
}

.qr-code {
    text-align: center;
    .subtitle {
        padding: 15px 0 30px;
    }
    .tips {
        padding-top: 25px;
    }
}


</style>



// WEBPACK FOOTER //
// src/components/create.vue